! function (e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.CanopyConnect = t() : e.CanopyConnect = t()
}(self, (function () {
    return (() => {
        "use strict";
        var e = {
                187: e => {
                    var t, n = "object" == typeof Reflect ? Reflect : null,
                        o = n && "function" == typeof n.apply ? n.apply : function (e, t, n) {
                            return Function.prototype.apply.call(e, t, n)
                        };
                    t = n && "function" == typeof n.ownKeys ? n.ownKeys : Object.getOwnPropertySymbols ? function (e) {
                        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))
                    } : function (e) {
                        return Object.getOwnPropertyNames(e)
                    };
                    var r = Number.isNaN || function (e) {
                        return e != e
                    };

                    function i() {
                        i.init.call(this)
                    }
                    e.exports = i, e.exports.once = function (e, t) {
                        return new Promise((function (n, o) {
                            function r(n) {
                                e.removeListener(t, i), o(n)
                            }

                            function i() {
                                "function" == typeof e.removeListener && e.removeListener("error", r), n([].slice.call(arguments))
                            }
                            m(e, t, i, {
                                once: !0
                            }), "error" !== t && function (e, t, n) {
                                "function" == typeof e.on && m(e, "error", t, {
                                    once: !0
                                })
                            }(e, r)
                        }))
                    }, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
                    var a = 10;

                    function s(e) {
                        if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e)
                    }

                    function c(e) {
                        return void 0 === e._maxListeners ? i.defaultMaxListeners : e._maxListeners
                    }

                    function l(e, t, n, o) {
                        var r, i, a, l;
                        if (s(n), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), i = e._events), a = i[t]), void 0 === a) a = i[t] = n, ++e._eventsCount;
                        else if ("function" == typeof a ? a = i[t] = o ? [n, a] : [a, n] : o ? a.unshift(n) : a.push(n), (r = c(e)) > 0 && a.length > r && !a.warned) {
                            a.warned = !0;
                            var d = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                            d.name = "MaxListenersExceededWarning", d.emitter = e, d.type = t, d.count = a.length, l = d, console && console.warn && console.warn(l)
                        }
                        return e
                    }

                    function d() {
                        if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments)
                    }

                    function u(e, t, n) {
                        var o = {
                                fired: !1,
                                wrapFn: void 0,
                                target: e,
                                type: t,
                                listener: n
                            },
                            r = d.bind(o);
                        return r.listener = n, o.wrapFn = r, r
                    }

                    function f(e, t, n) {
                        var o = e._events;
                        if (void 0 === o) return [];
                        var r = o[t];
                        return void 0 === r ? [] : "function" == typeof r ? n ? [r.listener || r] : [r] : n ? function (e) {
                            for (var t = new Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
                            return t
                        }(r) : h(r, r.length)
                    }

                    function p(e) {
                        var t = this._events;
                        if (void 0 !== t) {
                            var n = t[e];
                            if ("function" == typeof n) return 1;
                            if (void 0 !== n) return n.length
                        }
                        return 0
                    }

                    function h(e, t) {
                        for (var n = new Array(t), o = 0; o < t; ++o) n[o] = e[o];
                        return n
                    }

                    function m(e, t, n, o) {
                        if ("function" == typeof e.on) o.once ? e.once(t, n) : e.on(t, n);
                        else {
                            if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
                            e.addEventListener(t, (function r(i) {
                                o.once && e.removeEventListener(t, r), n(i)
                            }))
                        }
                    }
                    Object.defineProperty(i, "defaultMaxListeners", {
                        enumerable: !0,
                        get: function () {
                            return a
                        },
                        set: function (e) {
                            if ("number" != typeof e || e < 0 || r(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                            a = e
                        }
                    }), i.init = function () {
                        void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0
                    }, i.prototype.setMaxListeners = function (e) {
                        if ("number" != typeof e || e < 0 || r(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
                        return this._maxListeners = e, this
                    }, i.prototype.getMaxListeners = function () {
                        return c(this)
                    }, i.prototype.emit = function (e) {
                        for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
                        var r = "error" === e,
                            i = this._events;
                        if (void 0 !== i) r = r && void 0 === i.error;
                        else if (!r) return !1;
                        if (r) {
                            var a;
                            if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
                            var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
                            throw s.context = a, s
                        }
                        var c = i[e];
                        if (void 0 === c) return !1;
                        if ("function" == typeof c) o(c, this, t);
                        else {
                            var l = c.length,
                                d = h(c, l);
                            for (n = 0; n < l; ++n) o(d[n], this, t)
                        }
                        return !0
                    }, i.prototype.addListener = function (e, t) {
                        return l(this, e, t, !1)
                    }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function (e, t) {
                        return l(this, e, t, !0)
                    }, i.prototype.once = function (e, t) {
                        return s(t), this.on(e, u(this, e, t)), this
                    }, i.prototype.prependOnceListener = function (e, t) {
                        return s(t), this.prependListener(e, u(this, e, t)), this
                    }, i.prototype.removeListener = function (e, t) {
                        var n, o, r, i, a;
                        if (s(t), void 0 === (o = this._events)) return this;
                        if (void 0 === (n = o[e])) return this;
                        if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete o[e], o.removeListener && this.emit("removeListener", e, n.listener || t));
                        else if ("function" != typeof n) {
                            for (r = -1, i = n.length - 1; i >= 0; i--)
                                if (n[i] === t || n[i].listener === t) {
                                    a = n[i].listener, r = i;
                                    break
                                } if (r < 0) return this;
                            0 === r ? n.shift() : function (e, t) {
                                for (; t + 1 < e.length; t++) e[t] = e[t + 1];
                                e.pop()
                            }(n, r), 1 === n.length && (o[e] = n[0]), void 0 !== o.removeListener && this.emit("removeListener", e, a || t)
                        }
                        return this
                    }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function (e) {
                        var t, n, o;
                        if (void 0 === (n = this._events)) return this;
                        if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;
                        if (0 === arguments.length) {
                            var r, i = Object.keys(n);
                            for (o = 0; o < i.length; ++o) "removeListener" !== (r = i[o]) && this.removeAllListeners(r);
                            return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this
                        }
                        if ("function" == typeof (t = n[e])) this.removeListener(e, t);
                        else if (void 0 !== t)
                            for (o = t.length - 1; o >= 0; o--) this.removeListener(e, t[o]);
                        return this
                    }, i.prototype.listeners = function (e) {
                        return f(this, e, !0)
                    }, i.prototype.rawListeners = function (e) {
                        return f(this, e, !1)
                    }, i.listenerCount = function (e, t) {
                        return "function" == typeof e.listenerCount ? e.listenerCount(t) : p.call(e, t)
                    }, i.prototype.listenerCount = p, i.prototype.eventNames = function () {
                        return this._eventsCount > 0 ? t(this._events) : []
                    }
                }
            },
            t = {};

        function n(o) {
            var r = t[o];
            if (void 0 !== r) return r.exports;
            var i = t[o] = {
                exports: {}
            };
            return e[o](i, i.exports, n), i.exports
        }
        n.d = (e, t) => {
            for (var o in t) n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: t[o]
            })
        }, n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t);
        var o = {};
        return (() => {
            var e, t, r, i;
            n.d(o, {
                    default: () => w
                }),
                function (e) {
                    e.UNOPENED = "UNOPENED", e.INTRO = "INTRO", e.SELECT_CARRIER = "SELECT_CARRIER", e.CREDS_FORM = "CREDS_FORM", e.IDV_OPTIONS = "IDV_OPTIONS", e.IDV_SUBMITION = "IDV_SUBMITION", e.SUCCESS = "SUCCESS", e.DRIVERS = "DRIVERS"
                }(t || (t = {})),
                function (e) {
                    e.NONE = "NONE", e.STARTED = "STARTED", e.AUTHENTICATED = "AUTHENTICATED", e.SUCCESS = "SUCCESS"
                }(r || (r = {})),
                function (e) {
                    e.NOT_AUTHENTICATED = "NOT_AUTHENTICATED", e.INTERNAL_ERROR = "INTERNAL_ERROR", e.PROVIDER_ERROR = "PROVIDER_ERROR", e.INSUFFICIENT_CREDENTIALS = "INSUFFICIENT_CREDENTIALS", e.IDENTITY_VERIFICATION_OPTIONS = "IDENTITY_VERIFICATION_OPTIONS", e.IDENTITY_VERIFICATION = "IDENTITY_VERIFICATION"
                }(i || (i = {}));
            var a = ((e = {})[t.INTRO] = i.INSUFFICIENT_CREDENTIALS, e[t.SELECT_CARRIER] = i.INSUFFICIENT_CREDENTIALS, e[t.CREDS_FORM] = i.INSUFFICIENT_CREDENTIALS, e[t.IDV_OPTIONS] = i.IDENTITY_VERIFICATION_OPTIONS, e[t.IDV_SUBMITION] = i.IDENTITY_VERIFICATION, e),
                s = n(187);
            const c = {
                publicAlias: "demo"
            };

            function l(e, t) {
                for (var n = 0; n < t.length; n++) {
                    var o = t[n];
                    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o)
                }
            }

            function d(e) {
                return function (e) {
                    if (Array.isArray(e)) return u(e)
                }(e) || function (e) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e)
                }(e) || function (e, t) {
                    if (e) {
                        if ("string" == typeof e) return u(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? u(e, t) : void 0
                    }
                }(e) || function () {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }()
            }

            function u(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for (var n = 0, o = new Array(t); n < t; n++) o[n] = e[n];
                return o
            }
            var f, p, h, m, v, y = (f = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'], p = function () {
                function e(t) {
                    var n = t.targetModal,
                        o = t.triggers,
                        r = void 0 === o ? [] : o,
                        i = t.onShow,
                        a = void 0 === i ? function () {} : i,
                        s = t.onClose,
                        c = void 0 === s ? function () {} : s,
                        l = t.openTrigger,
                        u = void 0 === l ? "data-micromodal-trigger" : l,
                        f = t.closeTrigger,
                        p = void 0 === f ? "data-micromodal-close" : f,
                        h = t.openClass,
                        m = void 0 === h ? "is-open" : h,
                        v = t.disableScroll,
                        y = void 0 !== v && v,
                        g = t.disableFocus,
                        _ = void 0 !== g && g,
                        b = t.awaitCloseAnimation,
                        E = void 0 !== b && b,
                        w = t.awaitOpenAnimation,
                        T = void 0 !== w && w,
                        I = t.debugMode,
                        S = void 0 !== I && I;
                    ! function (e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }(this, e), this.modal = document.getElementById(n), this.config = {
                        debugMode: S,
                        disableScroll: y,
                        openTrigger: u,
                        closeTrigger: p,
                        openClass: m,
                        onShow: a,
                        onClose: c,
                        awaitCloseAnimation: E,
                        awaitOpenAnimation: T,
                        disableFocus: _
                    }, r.length > 0 && this.registerTriggers.apply(this, d(r)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this)
                }
                var t, n;
                return t = e, (n = [{
                    key: "registerTriggers",
                    value: function () {
                        for (var e = this, t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
                        n.filter(Boolean).forEach((function (t) {
                            t.addEventListener("click", (function (t) {
                                return e.showModal(t)
                            }))
                        }))
                    }
                }, {
                    key: "showModal",
                    value: function () {
                        var e = this,
                            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                        if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                            var n = function t() {
                                e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode()
                            };
                            this.modal.addEventListener("animationend", n, !1)
                        } else this.setFocusToFirstNode();
                        this.config.onShow(this.modal, this.activeElement, t)
                    }
                }, {
                    key: "closeModal",
                    value: function () {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                            t = this.modal;
                        if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                            var n = this.config.openClass;
                            this.modal.addEventListener("animationend", (function e() {
                                t.classList.remove(n), t.removeEventListener("animationend", e, !1)
                            }), !1)
                        } else t.classList.remove(this.config.openClass)
                    }
                }, {
                    key: "closeModalById",
                    value: function (e) {
                        this.modal = document.getElementById(e), this.modal && this.closeModal()
                    }
                }, {
                    key: "scrollBehaviour",
                    value: function (e) {
                        if (this.config.disableScroll) {
                            var t = document.querySelector("body");
                            switch (e) {
                                case "enable":
                                    Object.assign(t.style, {
                                        overflow: ""
                                    });
                                    break;
                                case "disable":
                                    Object.assign(t.style, {
                                        overflow: "hidden"
                                    })
                            }
                        }
                    }
                }, {
                    key: "addEventListeners",
                    value: function () {
                        this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown)
                    }
                }, {
                    key: "removeEventListeners",
                    value: function () {
                        this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown)
                    }
                }, {
                    key: "onClick",
                    value: function (e) {
                        e.target.hasAttribute(this.config.closeTrigger) && this.closeModal(e)
                    }
                }, {
                    key: "onKeydown",
                    value: function (e) {
                        27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e)
                    }
                }, {
                    key: "getFocusableNodes",
                    value: function () {
                        var e = this.modal.querySelectorAll(f);
                        return Array.apply(void 0, d(e))
                    }
                }, {
                    key: "setFocusToFirstNode",
                    value: function () {
                        var e = this;
                        if (!this.config.disableFocus) {
                            var t = this.getFocusableNodes();
                            if (0 !== t.length) {
                                var n = t.filter((function (t) {
                                    return !t.hasAttribute(e.config.closeTrigger)
                                }));
                                n.length > 0 && n[0].focus(), 0 === n.length && t[0].focus()
                            }
                        }
                    }
                }, {
                    key: "retainFocus",
                    value: function (e) {
                        var t = this.getFocusableNodes();
                        if (0 !== t.length)
                            if (t = t.filter((function (e) {
                                    return null !== e.offsetParent
                                })), this.modal.contains(document.activeElement)) {
                                var n = t.indexOf(document.activeElement);
                                e.shiftKey && 0 === n && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && n === t.length - 1 && (t[0].focus(), e.preventDefault())
                            } else t[0].focus()
                    }
                }]) && l(t.prototype, n), e
            }(), h = null, m = function (e) {
                if (!document.getElementById(e)) return console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1
            }, v = function (e, t) {
                if (function (e) {
                        e.length <= 0 && (console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'))
                    }(e), !t) return !0;
                for (var n in t) m(n);
                return !0
            }, {
                init: function (e) {
                    var t = Object.assign({}, {
                            openTrigger: "data-micromodal-trigger"
                        }, e),
                        n = d(document.querySelectorAll("[".concat(t.openTrigger, "]"))),
                        o = function (e, t) {
                            var n = [];
                            return e.forEach((function (e) {
                                var o = e.attributes[t].value;
                                void 0 === n[o] && (n[o] = []), n[o].push(e)
                            })), n
                        }(n, t.openTrigger);
                    if (!0 !== t.debugMode || !1 !== v(n, o))
                        for (var r in o) {
                            var i = o[r];
                            t.targetModal = r, t.triggers = d(i), h = new p(t)
                        }
                },
                show: function (e, t) {
                    var n = t || {};
                    n.targetModal = e, !0 === n.debugMode && !1 === m(e) || (h && h.removeEventListeners(), (h = new p(n)).showModal())
                },
                close: function (e) {
                    e ? h.closeModalById(e) : h.closeModal()
                }
            });
            window.MicroModal = y;
            const g = y;
            var _, b = function () {
                    function e(e) {
                        var t = this,
                            n = document.querySelector("#canopy-connect-modal-content");
                        if (!n) throw new Error("Failed to find iframe parent #canopy-connect-modal-content, error adding snippet to body");
                        this.iframe = document.createElement("iframe"), this.publicAlias = e.publicAlias, this.consentToken = e.consentToken, this.iframe.setAttribute("src", this.generateSrc()), this.iframe.setAttribute("style", "width: 100%; flex: 1 1 auto;"), this.iframe.setAttribute("class", "canopy-iframe"), this.iframe.setAttribute("frameborder", "0"), n.appendChild(this.iframe), this.onReady = new Promise((function (e) {
                            t.iframe.onload = e
                        }))
                    }
                    return e.prototype.postMessage = function (e) {
                        var t = this.iframe.contentWindow;
                        if (!t) throw new Error("Failed to get iframe contentWindow");
                        t.postMessage(e, "*")
                    }, e.prototype.generateSrc = function () {
                        var e = "";
                        return this.refreshToken ? e = "&refreshToken=" + this.refreshToken : this.consentToken && (e = "&consentToken=" + this.consentToken), "https://app.usecanopy.com/c/" + this.publicAlias + "?modal=true" + e
                    }, e.prototype.gotoStartOfFlow = function () {
                        this.iframe.setAttribute("src", this.generateSrc())
                    }, e
                }(),
                E = (_ = function (e, t) {
                    return (_ = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
                        })(e, t)
                }, function (e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

                    function n() {
                        this.constructor = e
                    }
                    _(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                });
            const w = function (e) {
                function n(n) {
                    var o = e.call(this) || this;
                    if (o._config = Object.assign({}, c, n), o._currentStage = t.INTRO, o._currentStatus = r.NONE, o._currentPullData = null, o.injectModalParent(), o.widgetHolder = function (e) {
                            return e.widgetHolder ? e.widgetHolder : new b(e)
                        }(n), o._config.pullMetaData) try {
                        JSON.stringify(o._config.pullMetaData)
                    } catch (e) {
                        throw new Error("pullMetaData must be json serializable")
                    }
                    o._config.onAuthenticationSuccess && o.on("authenticationSuccess", o._config.onAuthenticationSuccess), o._config.onExit && o.on("exit", o._config.onExit), o._config.onDestroy && o.on("destroy", o._config.onDestroy);
                    var i = function () {
                        var e = .01 * window.innerHeight;
                        document.documentElement.style.setProperty("--vh", e + "px")
                    };
                    i(), window.addEventListener("resize", i), o.once("destroy", (function () {
                        return window.removeEventListener("resize", i)
                    }));
                    var a = function (e) {
                        var t, n;
                        switch (null === (t = null == e ? void 0 : e.data) || void 0 === t ? void 0 : t.canopy_event) {
                            case "stage_update":
                                o.handleStageUpdate(e.data);
                                break;
                            case "status_update":
                                o.handleStatusUpdate(e.data);
                                break;
                            case "ready":
                                o.handleReadyWidget();
                                break;
                            case "selected_other_carrier":
                                o.handleSelectedOtherCarrier(e.data);
                                break;
                            case "refresh_token":
                                o.widgetHolder.refreshToken = null === (n = e.data) || void 0 === n ? void 0 : n.refresh_token;
                                break;
                            default:
                                return
                        }
                    };
                    return window.addEventListener("message", a), o.once("destroy", (function () {
                        return window.removeEventListener("message", a)
                    })), o
                }
                return E(n, e), n.create = function (e) {
                    return new n(e)
                }, n.prototype.injectModalParent = function () {
                    var e, t = this,
                        n = document.querySelector("body");
                    if (!n) throw new Error("Failed to find body within dom");
                    for (var o = 0, r = ['<style>@namespace svg "http://www.w3.org/2000/svg";.canopy-modal,.canopy-modal :not(svg|*){all:revert}.canopy__modal__overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.6);display:flex;justify-content:center;align-items:center;z-index:9999999}.canopy__modal__close{background:0 0;border:0;margin-left:auto!important}.canopy__modal__container{border-radius:4px;box-sizing:border-box;width:360px;display:flex;flex-direction:column}.canopy__modal__header{display:flex;justify-content:space-between;align-items:center}.canopy__modal__title{margin-top:0;margin-bottom:0;font-weight:600;font-size:1.25rem;line-height:1.25;color:#00449e;box-sizing:border-box}.canopy__modal__close:before{content:"\\2715"}.canopy__modal__content{background-color:transparent;height:550px;margin-top:1rem;margin-bottom:2rem;line-height:1.5;color:rgba(0,0,0,.8);display:flex;flex:1 1 auto;flex-direction:column}.canopy__modal__btn{font-size:.875rem;padding-left:.75rem;padding-right:.75rem;padding-top:.5rem;padding-bottom:.5rem;background-color:#e6e6e6;color:rgba(0,0,0,.8);border-radius:100rem;border-style:none;border-width:0;cursor:pointer;-webkit-appearance:button;text-transform:none;overflow:visible;line-height:1.15;margin:0;will-change:transform;-moz-osx-font-smoothing:grayscale;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateZ(0);transform:translateZ(0);transition:-webkit-transform .25s ease-out;transition:transform .25s ease-out;transition:transform .25s ease-out,-webkit-transform .25s ease-out}.canopy__modal__btn:focus,.canopy__modal__btn:hover{-webkit-transform:scale(1.05);transform:scale(1.05)}.canopy__modal__btn-primary{background-color:#00449e;color:#fff}@keyframes mmfadeIn{from{opacity:0}to{opacity:1}}@keyframes mmfadeOut{from{opacity:1}to{opacity:0}}.canopy-modal{display:none}.canopy-modal.is-open{display:block}.canopy-modal[aria-hidden=false] .canopy__modal__container,.canopy-modal[aria-hidden=false] .canopy__modal__overlay{animation:mmfadeIn .3s cubic-bezier(0,0,.2,1)}.canopy-modal[aria-hidden=true] .canopy__modal__container,.canopy-modal[aria-hidden=true] .canopy__modal__overlay{animation:mmfadeOut .3s cubic-bezier(0,0,.2,1)}.canopy-modal .canopy__modal__container,.canopy-modal .canopy__modal__overlay{will-change:transform}.canopy__button{color:#fff;background:#3f5dff;padding:.5rem 1rem;display:inline-block;border-radius:4px;transition-duration:.25s;border:none;font-size:14px;font-weight:500;text-decoration:none;font-family:Lato,\'Helvetica Neue\',Arial,Helvetica,sans-serif}.canopy-iframe{border:0;border-radius:8px}@media only screen and (max-width:480px),screen and (max-height:635px){.canopy__modal__container{width:100vw}.canopy__modal__content{height:100vh;height:calc(var(--vh,1vh) * 100)}.canopy__modal__btn{position:fixed;top:10px;right:10px;padding-top:0;padding-bottom:0;font-size:1.5rem;background-color:transparent}.canopy__modal__content{margin-top:0;margin-bottom:0}.canopy-iframe{border-radius:0}}</style>', '<div class="canopy-modal" id="canopy-connect-modal" aria-hidden="true"><div class="canopy__modal__overlay" tabindex="-1" data-micromodal-close><div class="canopy__modal__container" role="dialog" aria-modal="true" aria-labelledby="canopy-connect-modal-title"><div class="canopy__modal__header" data-micromodal-close><button class="canopy__modal__close canopy__modal__btn" aria-label="Close modal" data-micromodal-close></button></div><div class="canopy__modal__content" id="canopy-connect-modal-content"></div></div></div></div>']; o < r.length; o++) {
                        var i = r[o],
                            a = document.createElement("template");
                        a.innerHTML = i.trim(), (null !== (e = a.content) && void 0 !== e ? e : a).childNodes.forEach((function (e) {
                            n.appendChild(e), t.once("destroy", (function () {
                                var t;
                                return null === (t = e.parentNode) || void 0 === t ? void 0 : t.removeChild(e)
                            }))
                        }))
                    }
                }, n.prototype.handleSelectedOtherCarrier = function (e) {
                    this._config.onSelectCustomInsuranceProvider && this._config.onSelectCustomInsuranceProvider({
                        providerName: e.insurer_name
                    })
                }, n.prototype.handleReadyWidget = function () {
                    this.widgetHolder.postMessage({
                        canopy_event: "metadata",
                        metadata: this._config.pullMetaData
                    })
                }, n.prototype.handleStageUpdate = function (e) {
                    var t = e.canopy_event,
                        n = e.stage;
                    if ("stage_update" !== t) throw new Error("Mismatched canopy event");
                    this._currentStage = n
                }, n.prototype.handleStatusUpdate = function (e) {
                    var t = e.canopy_event,
                        n = e.status,
                        o = e.pull,
                        i = o.pull_id,
                        a = o.metadata;
                    if ("status_update" !== t) throw new Error("Mismatched canopy event");
                    switch (this._currentStatus = n, n) {
                        case r.STARTED:
                            this._currentPullData = {
                                pull: {
                                    pull_id: i,
                                    metadata: a
                                }
                            };
                            break;
                        case r.AUTHENTICATED:
                            this.emit("authenticationSuccess", {
                                pull: {
                                    pull_id: i,
                                    metadata: a
                                }
                            });
                            break;
                        case r.SUCCESS:
                            this._currentPullData = {
                                pull: {
                                    pull_id: i,
                                    metadata: a
                                }
                            }, this.close()
                    }
                }, n.prototype.open = function () {
                    var e = this;
                    this._currentStage = t.INTRO, g.show("canopy-connect-modal", {
                        onClose: function () {
                            "AUTHENTICATED" !== e._currentStatus && "SUCCESS" !== e._currentStatus && Object.keys(a).includes(e._currentStage) ? e.emit("exit", {
                                error_code: a[e._currentStage]
                            }, e._currentPullData) : e.emit("exit", null, e._currentPullData), e.widgetHolder.gotoStartOfFlow(), e._currentPullData = null
                        }
                    })
                }, n.prototype.close = function () {
                    g.close("canopy-connect-modal")
                }, n.prototype.destroy = function () {
                    this.emit("destroy")
                }, n
            }(s.EventEmitter)
        })(), o.default
    })()
}));